import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../commons/cart.service';
import { ConfigService } from '../commons/config.service';
import { UtilitiesService } from '../commons/utilities.service';
import { WebsiteInterfaceService } from '../commons/website-interface.service';


@Component({
  selector: 'no-content',
  template: require('./upload-photo.component.html'),
  styles: [`
    #photoEditBar { margin-bottom:8px; }
  `]
})

export class UploadPhotoComponent implements AfterViewInit {

  public visibleLoader: boolean = true;

  constructor(
    private router: Router,
    public cartService: CartService,
    public config: ConfigService,
    private utilities: UtilitiesService,
    private output: WebsiteInterfaceService,
  ) {
  }

  public formatIdeal() {
    return Number(this.cartService.cart.currentCartProduct.naturalWidth / this.config.RappRisoluzMin).toFixed(0);
  }

  ngAfterViewInit() {
    this.visibleLoader = false;
  }

  fileChange(fuImage: HTMLInputElement) {
    if (!fuImage.files || !fuImage.files[0]) {
      return;
    }

    let reader = new FileReader();
    let file = fuImage.files[0];
    let that = this;

    reader.onload = function (event) {
      that.visibleLoader = true;

      // let data = reader.result;
      that.cartService.cart = that.cartService.cart;

      // let body = {
      //   photoID: that.cartService.cart.currentCartProduct.photoID,
      //   photoBase64: data
      // };

      //console.log('INIT - requestAngular2');
      that.utilities.fileUpload('fileChange', file).subscribe(
        result => {
          if (result && result.result === 'ok') {
            that.cartService.cart.currentCartProduct.naturalWidth = result.naturalWidth;
            that.cartService.cart.currentCartProduct.naturalHeight = result.naturalHeight;
            //console.log('result.nameFile: ' + result.nameFile);


            let nameFile = result.nameFile;
            that.cartService.cart.currentCartProduct.photoID = nameFile;
            that.cartService.cart.currentCartProduct.photoOriginal =
              that.config.urlHost + '/files/temp/' + nameFile + '_web.jpg';
            //console.log('photoOriginal: ' + that.cartService.cart.currentCartProduct.photoOriginal);

            that.cartService.cart.currentCartProduct.photoResized = null;
            that.cartService.cart.formatoSelected = false;

            that.cartService.saveCart();

            that.visibleLoader = false;

          } else {
            that.visibleLoader = false;
            console.error(result);
            alert('Errore nell\'upload della foto!\r\nImmagine troppo pesante');
          }
        },
        error => {
          that.visibleLoader = false;
          console.error(error);
          alert('Errore nell\'upload della foto!\r\nImmagine troppo pesante');
        }
      );
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/upload-photo.component.ts